import { Link } from "@tanstack/react-router";
import { User as UserIcon } from "lucide-react";
import { ClientOnly, getImageProps, getImageUrl, splitSlug } from "@/lib/utils";

export function ArticleCard({
  article,
  size = "default",
}: {
  article: any;
  size?: "default" | "compact";
}) {
  const date = new Date(article.publishedAt || article.createdAt).toLocaleDateString("id-ID", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

  const postRoute = article.type === "NOVEL" 
    ? "/novel/$id/$slug" 
    : article.type === "SHORTSTORY" 
      ? "/cerpen/$id/$slug" 
      : article.type === "POETRY" 
        ? "/puisi/$id/$slug" 
        : "/artikel/$id/$slug";

  const postParams = splitSlug(article.slug || "");

  return (
    <div className="group relative block space-y-4">
      <div className="overflow-hidden rounded-2xl aspect-[4/3] bg-muted border border-border/50 shadow-sm transition-all duration-500 group-hover:shadow-xl group-hover:shadow-accent/5 group-hover:border-accent/20">
        <img
          {...getImageProps(article.coverImage)}
          alt={article.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
      </div>
      <div className="space-y-3">
        <div className="flex items-center justify-between gap-2">
          <span className="text-[10px] uppercase tracking-[0.2em] text-accent font-bold">
            {article.categories?.[0]?.name || "Utama"}
          </span>
          <ClientOnly>
            <span className="text-[10px] uppercase tracking-widest text-muted-foreground font-bold">{date}</span>
          </ClientOnly>
        </div>
        <h3
          className={`font-serif font-medium leading-tight group-hover:text-accent transition-colors duration-300 ${
            size === "compact" ? "text-lg md:text-xl" : "text-2xl md:text-3xl"
          }`}
        >
          <Link
            to={postRoute as any}
            params={postParams}
            className="after:absolute after:inset-0"
          >
            {article.title}
          </Link>
        </h3>
        <p className="text-muted-foreground text-sm leading-relaxed line-clamp-2 font-serif italic opacity-95">
          {article.excerpt}
        </p>
        <div className="pt-2 flex items-center gap-3 relative z-10">
           <div className="w-6 h-6 rounded-full bg-muted overflow-hidden border border-border/50 shrink-0">
              {article.author?.avatar ? (
                <img src={getImageUrl(article.author.avatar)} alt={article.author.name} className="w-full h-full object-cover" />
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-accent/10 text-accent">
                  <UserIcon size={16} className=" " />
                </div>
              )}
           </div>
           <Link
             to="/penulis/$slug"
             params={{ slug: article.author?.slug || article.authorId.toString() }}
             className="text-[11px] uppercase tracking-widest font-bold text-muted-foreground hover:text-accent transition-colors"
           >
             {article.author?.name}
           </Link>
        </div>
      </div>
    </div>
  );
}
